/** Addresses that held a configuration screen, and the part of Settings that holds it now. */
const MOVED = new Map([
  ['/audit', '/settings?tab=audit'],
  ['/pipeline/consultation-settings', '/settings?tab=sales&item=consultation'],
  ['/pricebook/controls', '/settings?tab=sales&item=pricing'],
]);

/** The Settings tabs that were renamed or folded into another, with where each went. */
const RENAMED_TABS = new Map([
  ['users', '/settings?tab=team&item=users'],
  ['roles', '/settings?tab=team&item=roles'],
  ['business', '/settings?tab=sales'],
]);

function withoutTrailingSlash(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

/**
 * Where an address that used to configure something now lives, so a bookmark still works.
 *
 * @param pathname the path of the location
 * @param search the query string of the location, with its leading `?`
 * @returns the address to go to instead, or null when this one still means what it did
 */
export function movedTo(pathname: string, search: string): string | null {
  const path = withoutTrailingSlash(pathname);
  const query = new URLSearchParams(search);
  if (path === '/proposals' && query.get('view') === 'templates') {
    return '/settings?tab=sales&item=proposals';
  }
  if (path === '/settings') {
    return RENAMED_TABS.get(query.get('tab') ?? '') ?? null;
  }
  return MOVED.get(path) ?? null;
}
